/**
 * 客户优惠券列表
 * */
import React from 'react';
import qs from 'query-string';
import { Spin,Button,Radio} from "antd";
import Lang from '@components/Lang/Lang'
import {getIntlYYMMDD,isEmpty,isEmptyObject,trim,getFileSuffix,symbolMoneyUtil} from '@utils/utils';
import PageCommon from  "@components/PageCommon/PageCommon";
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import AutoFetchList from '@components/AutoFetchList/AutoFetchList';
import Coupon from "./components/Coupon";
import Status from "./components/Status";
import { toFixedWithCommas} from "@utils/number-util";
// import dayjs from 'dayjs';
import "./index.less";
const ButtonGroup = Button.Group;
export default class CouponList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,
            buyerId:"",
            customerObj:{},
            active: "0",
            status:'enable',
            isHideOrderBy:false
        }
    }
    
    loading(flag){
        this.setState({
            loading: flag
        })
    }
    
    // 渲染优惠券卡片
    renderCouponCard = (item,inx) => {
        return <Coupon key={inx} item={item}></Coupon>;
    };
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    // 列表
    onRefAutoFetchList = (ref) =>  this.onRefAutoFetchListChild = ref;
    

    fetchBack(data={}){
        const {success,valid,paging,model={} } = data;
        if(success&&valid&&model){
            this.setState({
                customerObj:model
            })
        }
    }
    // 获取数据
    getData(){  
        this.onRefAutoFetchListChild && this.onRefAutoFetchListChild.handleFetch(1,true);
    }
    /**
     * 修改状态
     **/
    changeStatue(value){
        let isHideOrderBy = false;
        if(value!='enable'){
            isHideOrderBy = true
        }
        this.setState({
            status:value,
            isHideOrderBy:isHideOrderBy
        },()=> {
            this.getData(1)
        })
    }
    /**
     * 切换优惠券
     */
    changeType(type){
        if(this.state.active != type){
            this.setState({
                active:type
            },function () {
                this.getData(1)
            })
        }

    }
    componentWillMount(){
        const {id} = qs.parse(this.props.location.search)
        this.setState({
            buyerId:id
        })
    }
    render() {
        const { loading, buyerId,status,isHideOrderBy=false,active } = this.state;
        return (
            <Spin spinning={loading}>
                <PageCommon>
                    <CommonBreadcrumb list={[
                        {name: Lang({id:'YiChengJiaoKeHu',default:"已成交客户"}),link:"/customer/completed"},
                        {name:Lang({id:'ZhangHaoXiangQing',default:"客户详情"}),link:"/customer/detail?id="+buyerId},
                        {name: Lang({id:'KeHuYouHuiQuan',default:"客户优惠券"})}
                    ]}></CommonBreadcrumb>
                    <div className={"coupon-list"}>
                        {/* 页面标题和操作按钮 */}
                        <div className="option-wrap">
                            <Status status={status} onClickItem={this.changeStatue.bind(this)}></Status>
                            {/*时间组件*/}
                            {
                                isHideOrderBy?
                                    null
                                    :
                                    <div>
                                        <Radio.Group value={active}>
                                            <Radio.Button value="0" onClick={()=>this.changeType("0")}>{__getServerLanguage('XinDaoZhang')}</Radio.Button>
                                            <Radio.Button value="1" onClick={()=>this.changeType("1")}>{__getServerLanguage('JiJiangGuoQi')}</Radio.Button>
                                        </Radio.Group>
                                    </div>
                            }
                        </div>
                        {/* 优惠券列表 */}
                        {buyerId?<AutoFetchList
                            onRef={this.onRefAutoFetchList}
                            fetchCallBack={(data) => this.fetchCallBack(data)}
                            precondition={status==='enable'?{
                                buyerId:buyerId,
                                orderBy:active,
                                status:status
                            }:{
                                buyerId:buyerId,
                                status:status
                            }}
                            fetchApi={'/mg/buyer/buyer/query/coupon-list'}
                            fetchCallBack={(data)=>this.fetchBack(data)}
                            // fetchApi={"/service/mg/fin/ddp/remittance-item/remittanceList"}
                            renderList={(item, inx) => this.renderCouponCard(item,inx)}
                            pageSize={12}
                        />:null}
                </div>
                </PageCommon>
            </Spin>
        );
    }
}